module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_bollnas-b58212f7dd70e6889cdc32e3940b3c9e.png";